import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=71b563f4&scoped=true&"
import script from "./PriceList.vue?vue&type=script&lang=js&"
export * from "./PriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b563f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b563f4')) {
      api.createRecord('71b563f4', component.options)
    } else {
      api.reload('71b563f4', component.options)
    }
    module.hot.accept("./PriceList.vue?vue&type=template&id=71b563f4&scoped=true&", function () {
      api.rerender('71b563f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/price/PriceList.vue"
export default component.exports